import type { IReferentialRepository } from '@/core/domain/referential/IReferentialRepository.ts'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory'
import { ReferentialAxis } from '@/core/domain/referential/axis/ReferentialAxis.ts'

import type { ReferentialUrlOptions } from '@/core/domain/referential/ReferentialUrlOptions.ts'
import { NabooError } from '@/core/infrastructure/services/NabooError.ts'

export class ReferentialRepository implements IReferentialRepository {
  async fetchAll(URLOptions?: ReferentialUrlOptions): Promise<ReferentialAxis[]> {
    let url = '/referential'

    if (URLOptions) {
      url += URLOptions.getUrlOptions()
    }

    const response = await apiService.get(url)

    // Vérifier si response est un tableau
    if (!Array.isArray(response.data)) {
      throw new NabooError({
        message: "La réponse API n'est pas un tableau",
        status: 500,
        name: 'ApiError',
        code: 'INVALID_RESPONSE_FORMAT'
      })
    }

    return response.data.map((axisData) => ReferentialAxis.create(axisData))
  }

  async fetchById(id: number, URLOptions?: ReferentialUrlOptions): Promise<ReferentialAxis> {
    let url = `/referential/${id}`

    if (URLOptions) url += URLOptions.getUrlOptions()

    const response = await apiService.get<ReferentialAxis>(url)

    return ReferentialAxis.create(response.data)
  }
}
